import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';

import { hideModal } from '../../../services/modal/actions';
import { logoutUser } from '../../../services/authentication/logout/actions';
import { sendDisenrollmentRequest } from '../../../services/disenrollment/actions';

import { formatAmount } from '../../../utils';
import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import { getWaitingAmount } from '../../../services/account/gains/selector';
import { getValidatedAmount } from '../../../services/account/gains/selector';

import SvgComponent from '../../SvgComponent';
import ButtonComponent from '../../button/ButtonComponent';
import { LoadingComponent } from '../../loading/LoadingComponent';

import './DisenrolModalComponent.scss';

class DisenrolModalComponent extends React.Component {
    submit = () => {
        const { sendDisenrollmentRequest, logoutUser } = this.props;

        sendDisenrollmentRequest(() => {
            logoutUser();
        });
    };

    handleAbort = () => {
        const { history, hideModal } = this.props;

        history.push(PATH.HOME_PATH);
        hideModal();
    };

    render() {
        const {
            i18n,
            validatedAmount,
            waitingAmount,
            requestSubmit,
            errorMessage,
            successDisenrollmentRequestSubmit
        } = this.props;

        return (
            <React.Fragment>
                {!successDisenrollmentRequestSubmit ? (
                    <div className="modal-disenrol">
                        <div className="container-header">{i18n.STEP1.HEADER}</div>
                        <div className="container-body">
                            <p className="title">{i18n.STEP1.TEXT1}</p>
                            <div className="cashback-wrapper">
                                {validatedAmount > 0 && (
                                    <div className="cashback valid">
                                        <span>
                                            <SvgComponent
                                                src={`${STATIC_ROOT}/compte/mes-achats/valide.svg`}
                                                width="15"
                                                height="15"
                                                aria-hidden="true"
                                                focusable="false"
                                            />
                                        </span>
                                        {convertHtmlToReactDomWithParams(
                                            i18n.STEP1.CASHBACK_VALID,
                                            formatAmount(validatedAmount)
                                        )}
                                    </div>
                                )}
                                {waitingAmount > 0 && (
                                    <div className="cashback waiting">
                                        <span>
                                            <SvgComponent
                                                src={`${STATIC_ROOT}/compte/mes-achats/lost.svg`}
                                                width="20"
                                                height="20"
                                                aria-hidden="true"
                                                focusable="false"
                                            />
                                        </span>
                                        {convertHtmlToReactDomWithParams(
                                            i18n.STEP1.CASHBACK_WAITING,
                                            formatAmount(waitingAmount)
                                        )}
                                    </div>
                                )}
                                <div className="cashback">{i18n.STEP1.TEXT2}</div>
                            </div>
                        </div>
                        <div className="container-button">
                            <ButtonComponent
                                id="disenroll-abort"
                                color="second"
                                text={i18n.STEP1.CTA_ABORT}
                                onClick={this.handleAbort}
                            />
                            <ButtonComponent
                                color="main"
                                text={i18n.STEP1.CTA_CONFIRM}
                                onClick={this.submit}
                            />
                        </div>
                        <div className="submit-container">
                            {requestSubmit && <LoadingComponent />}
                            {errorMessage && <p className="color-err">{errorMessage}</p>}
                        </div>
                    </div>
                ) : (
                    <div className="modal-disenrol-confirm">
                        <div className="container-body">
                            <span>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/compte/mes-achats/valide.svg`}
                                    width="50"
                                    height="40"
                                    aria-hidden="true"
                                    focusable="false"
                                />
                            </span>
                            <p className="title">{i18n.STEP2.TEXT1}</p>
                            <p>{i18n.STEP2.TEXT2}</p>
                            <p>{i18n.STEP2.TEXT3}</p>
                        </div>
                        <div className="container-button">
                            <ButtonComponent
                                id="disenrolled-ok"
                                color="main"
                                text={i18n.STEP2.CTA_OK}
                                onClick={this.handleAbort}
                            />
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

DisenrolModalComponent.propTypes = {
    i18n: PropTypes.object
};

// Which props do we want to inject, given the global state?
const mapStateToProps = state => {
    return {
        validatedAmount: getValidatedAmount(state),
        waitingAmount: getWaitingAmount(state),
        i18n: state.i18n.page.DISENROLLMENT_MODAL,
        errorMessage: state.disenrollment.error || '',
        requestSubmit: state.disenrollment.fetching || false,
        successDisenrollmentRequestSubmit: state.disenrollment.successDisenrollmentRequestSubmit,
        pathname: state.routing.location.pathname
    };
};
const mapDispatchToProps = {
    hideModal,
    sendDisenrollmentRequest,
    logoutUser
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DisenrolModalComponent));



// WEBPACK FOOTER //
// ./src/components/authentication/disenrollment/DisenrolModalComponent.js